<template>
  <apexchart
    type="line"
    :options="chartOptions"
    :series="updatedSeries"
    height="350"
    class="mixed-chart-mobile"
  />
</template>

<script>
  import { toFixed, lensMatching, round } from '../../../utils/ramda-utils'
  import { propEq, propOr, compose, converge, reduce, head, identity, view, max, curry, map, lensProp, over, sortBy, prop } from 'ramda'
  import { BLUE, GREEN, PURPLE, PINK } from '@/constants/charts'

  const lensByName = compose(lensMatching, propEq('name'))
  const maxValue = curry((propName,context) => {
    const maxValue = compose(
      converge(
        reduce(max),
        [
          head,
          identity
        ]
      ),
      propOr([], 'data'),
      view(lensByName(propName)),
      propOr([], 'series')
    )(context)

    return maxValue
  })

  export default {
    props: {
      series: {
        type: Array,
        default: () => [{
            name: this.$t('charts.mix.number_of_minutes'),
            type: 'line',
            data: [1, 2, 10]
        },{
            name: this.$t('charts.mix.number_of_lessons'),
            type: 'column',
            data: [1, 0, 100]
          }],
      },
      labels: {
        type: Array,
        default: () => []
      },
      titleY: {
        type: String,
        default: ''
      },
      titleYOpposite: {
        type: String,
        default: ''
      },
      colorLine: {
        type: String,
        default: BLUE
      },
      colorColumn: {
        type: String,
        default: GREEN
      }
    },
    computed: {
      updatedSeries(){
        return compose(
          sortBy(prop('name')),
          map(over(lensProp('name'), (name) => this.$t(`charts.${name}`))),
          propOr([], 'series')
        )(this)
      },
      maxNumberOfLessons: maxValue('number_of_lessons'),
      maxNumberOfMinutes: maxValue('number_of_seconds'),
      numberOfLessonsTickAmount() {
        const ticks = this.maxNumberOfLessons < 6 ? round(this.maxNumberOfLessons) : 6
        return parseInt(ticks)
      },
      numberOfMinutesTickAmount() {
        const ticks = this.maxNumberOfMinutes < 6 ? round(this.maxNumberOfMinutes) : 6
        return parseInt(ticks)
      },
      chartOptions() {
        return {
          chart: {
            animations: {
              enabled: true,
            },
            type: 'line',
            toolbar:{
              show: false,
            }
          },
          stroke: {
            width: [0, 4]
          },
          dataLabels: {
            enabled: true,
            enabledOnSeries: [1],
            formatter: toFixed(0)
          },
          xaxis: {
            type: 'category',
            categories: this.labels,
            labels: {
              show: true,
            }
          },
          colors: [this.colorLine, this.colorColumn],
          yaxis: [{
            tickAmount: this.numberOfMinutesTickAmount,
            labels: { 
              formatter: toFixed(0),
              style: { 
                color: this.colorLine,
                cssClass: 'apexcharts-yaxis-label'
              }
            },
            title: {
              text: this.titleY,
              style: { color: this.colorLine }
            },
            axisBorder: {
              show: true,
              color: this.colorLine,
            },
          }, {
            opposite: true,
            tickAmount: this.numberOfLessonsTickAmount,
            labels: { 
              formatter: toFixed(0),
              style: { color: this.colorColumn }
            },
            title: {
              text: this.titleYOpposite,
              style: { color: this.colorColumn }
            },
            axisBorder: {
              show: true,
              color: this.colorColumn
            },
          }],
          states: {
            hover: {
              filter: {
                type: 'none'
              }
            }
          },
          grid: {
            show: false
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.mixed-chart-mobile {
  min-width: 600px;
}
</style>
